<template>
  <div>
    <div class="close-img-menu" v-if="isManualPage">
      <img class="close-img" :src="closeImg" alt="close" @click="closeTab" />
    </div>
    <div class="user-menu" v-if="!isManualPage">
      <ul class="user-dropdown">
        <li>
          <router-link to="/profile">{{
            $t("userNav.link.profile")
          }}</router-link>
        </li>
        <li>
          <router-link to="/logout" @click.native="logout">{{
            $t("userNav.link.signOut")
          }}</router-link>
        </li>
      </ul>
    </div>
    <ul class="plan-menu" v-if="!isManualPage">
      <li>
        <router-link to="/plans"
          ><img class="plan-img" :src="dashboardImg" alt="Dashboard"
        /></router-link>
      </li>
      <li>
        <router-link to="/notification"
          ><img class="plan-img" :src="notificationImg" alt="Notification"
        /></router-link>
      </li>
      <li v-if="user.userType === 1">
        <router-link to="/admin"
          ><img class="plan-img" :src="adminImg" alt="Admin"
        /></router-link>
      </li>
      <li>
        <router-link to="/manual#1" target="_blank"
          ><img class="user-manual-img" :src="userManualImg" alt="User manual"
        /></router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { userService } from "@/services/user.service";

export default {
  name: "UserNav",
  data() {
    return {
      user: {},
      dashboardImg: require("@/assets/icons/home.png"),
      notificationImg: require("@/assets/icons/notifications_none.png"),
      adminImg: require("@/assets/icons/settings.png"),
      userManualImg: require("@/assets/icons/manual.png"),
      closeImg: require("@/assets/icons/modal-close.png"),
      isManualPage: false,
    };
  },
  mounted: function() {
    // grab the user
    let user = JSON.parse(localStorage.getItem("user"));
    this.user = user.userInfo;
    if (this.$route.path.includes("manual")) {
      this.isManualPage = true;
    }
  },
  methods: {
    logout: function() {
      userService.logout().then(() => {
        // console.log("logout");
      });
    },
    closeTab() {
      window.close();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.plan-menu {
  margin: 10px;
  li a {
    line-height: 50px;
  }
}
.user-menu {
  position: relative;
  float: right;
  width: 40px;
  height: 40px;
  margin: 0 5px;
  background: url("../assets/icons/account_circle.png") no-repeat;
  &:hover ul.user-dropdown {
    display: block;
  }
}

.plan-img {
  width: 25px;
  height: 25px;
}

.user-manual-img {
  width: 25px;
  height: 25px;
}

.close-img-menu {
  height: 50px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}

.close-img {
  width: 16px;
  height: 16px;
}

.close-img:hover {
  cursor: pointer;
}

ul.user-dropdown {
  position: absolute;
  display: none;
  background: $surface-alpha;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 0 15px;
  color: $text-dark;
  width: 180px;
  top: 40px;
  left: -110px;

  li {
    display: block;
    margin: 0;
    text-align: left;
    border-bottom: 1px solid $border-alpha;
    &:last-child {
      border: none;
    }
  }
  li a {
    display: block;
    color: $text-alpha;
    padding: 20px 0 20px 21px;
  }
}
</style>
